// To add on all the pages. Contains all the tracking stuff. Should be heavily
// cleaned up!
import './qts';
import './ttref';

const urlParam = name => {
  const results = new RegExp(`[\\?&]${name}=([^&#]*)`)
      .exec(window.location.href);
  if (results == null) {
    return null;
  }

  return results[1] || 0;
};

if (urlParam('uniqid')) {
  _t.push(['email-tracking.clicked',
    {
      url: document.URL,
      uniqid: urlParam('uniqid'),
      os: navigator ? navigator.platform : '',
      browser: navigator ? navigator.userAgent : '',
      locale: navigator ? navigator.language : '',
    }]);
} else if (urlParam('program')) {
  _t.push(['campaign_click',
    {
      program: urlParam('program'),
      program_id: urlParam('program_id'),
      uid: urlParam('uid'),
    }]);
} else if (urlParam('utm_expid')) {
  const re = /^(\d+-\d+)/;
  const m = re.exec(urlParam('utm_expid'));

  if (m[0]) {
    _t.push(['abtest',
      {
        test: m[0],
        variation: urlParam('t'),
      }]);
  }
}

if (window.performance && window.performance.mark) {
  window.performance.mark('tracking_ready');
}
